import { CustomBookingMethodStep } from '~api/config';

import { Fragment } from 'react';

import { Card, ListLayout } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

interface Props {
  steps: CustomBookingMethodStep[];
}

export function StepList({ steps }: Props) {
  const { t } = useTranslation();

  const Wrapper = steps.length > 1 ? Card.InnerContent : Fragment;

  return (
    <Fragment>
      {steps.map((step, index) => (
        <Wrapper key={`drawer-step-${index}`}>
          <ListLayout.Column>
            <ListLayout.Stack>
              <ListLayout.SecondaryText>{t('common.ruleName')}</ListLayout.SecondaryText>
              <ListLayout.PrimaryText>{step.name}</ListLayout.PrimaryText>
            </ListLayout.Stack>

            <ListLayout.Stack>
              <ListLayout.SecondaryText>{t('common.conditions')}</ListLayout.SecondaryText>
              <ListLayout.PrimaryText>
                {step.filters?.map((filter, fi) => (
                  <div key={`drawer-step-${fi}-filters-${fi}`}>{filter.expression}</div>
                ))}
              </ListLayout.PrimaryText>
            </ListLayout.Stack>

            <ListLayout.Stack>
              <ListLayout.SecondaryText>{t('common.actions')}</ListLayout.SecondaryText>
              <ListLayout.PrimaryText>
                {step.actions?.map((action, ai) => (
                  <div key={`drawer-step-${ai}-actions-${ai}`}>{action.expression}</div>
                ))}
              </ListLayout.PrimaryText>
            </ListLayout.Stack>
          </ListLayout.Column>
        </Wrapper>
      ))}
    </Fragment>
  );
}
